// istanbul ignore file

type ComplianceAgency = {
    complianceAgencyId: number;
    complianceAgencyGroupId: number | null;
    complianceAgencyName: string;
    complianceAgencyState: string;
    isMaster: boolean;
    isDefault: boolean;
};

type BffSession = {
    complianceUserId: number;
    complianceAgencyGroupId: number | null;
    complianceUserName: string;
    complianceUserEmail: string;
    complianceUserRole: string;
    complianceSystemUrl: string;
    complianceAgencyId: number;
    complianceAgencyName: string;
    complianceAgencyState: string;
    isComplianceAgencyUserMaster: boolean;
    isComplianceAgencyUserDefault: boolean;
    requiresRelogin: boolean;
    isImpersonating: boolean;
    showUsernameLoginBanner: boolean;
    UNSAFE_originalComplianceUserId?: string | null;
};

type LoginSystem = {
    shortName: string;
    displayName: string;
    complianceStateId: number;
    baseUrl: string;
};

enum SystemStateName {
    VICTORIA = 'VIC',
    NEW_SOUTH_WALES = 'NSW',
    QUEENSLAND = 'QLD',
    SOUTH_AUSTRALIA = 'SA',
    TASMANIA = 'TAS',
    NORTHERN_TERRITORY = 'NT',
    WESTERN_AUSTRALIA = 'WA',
    AUSTRALIAN_CAPITAL_TERRITORY = 'ACT'
}

// istanbul ignore next
enum StateId {
    ACT = 1,
    NSW = 2,
    NT = 3,
    QLD = 4,
    SA = 5,
    TAS = 6,
    VIC = 7,
    WA = 8
}

// istanbul ignore next
enum StateShortName {
    ACT = 'act',
    NSW = 'nsw',
    NT = 'nt',
    QLD = 'qld',
    SA = 'sa',
    TAS = 'tas',
    VIC = 'vic',
    WA = 'wa'
}

export {
    ComplianceAgency, BffSession, LoginSystem, StateId, StateShortName, SystemStateName,
};
